import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository.ts";
import type { Nullable } from "@core/domain/types/nullable.type";
import type { PlotFile, PlotFileUpload } from "@farm/domain/models/plot.model";
import type { FarmRepository } from "@farm/domain/repositories/farm.repository";
import { farmTypes } from "@farm/farm-types.di";
import { RecuperableModelError } from "@iot-platform/core";
import { inject, injectable } from "inversify";

@injectable()
export class PlotFileUploadUseCase {
    constructor(
        @inject(farmTypes.repositories.FarmRepository)
        private readonly farmRepository: FarmRepository,
    ) {}

    async execute(
        plotId: string,
        farmId: string,
        plotFile: PlotFileUpload,
    ): Promise<Nullable<PlotFile>> {
        const uploadResult = await this.farmRepository.uploadFile(
            plotId,
            farmId,
            plotFile,
        );

        return uploadResult.match(
            (file) => {
                ToastManagerRepository.success();
                return file;
            },
            (error) => {
                if (error instanceof RecuperableModelError) {
                    ToastManagerRepository.warning(error.message);
                    return error.instance;
                }
                ToastManagerRepository.error(error.message);
                return null;
            },
        );
    }
}
